// Cockpit brand mark: the Ampersand "&" set inside an olive rounded-square tile.
// Source: ui/public/cockpit-mark.svg (inlined here so React can size it freely).
//
// Colors are fixed to the brand palette (olive tile + cream glyph) because the
// mark is two-tone. `strokeWidth` is accepted for backwards compatibility but
// not used by this design.

type Props = {
  size?: number;
  strokeWidth?: number;
  className?: string;
  title?: string;
};

export function CandyGlyph({
  size = 22,
   
  strokeWidth: _strokeWidth,
  className,
  title,
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      {title ? <title>{title}</title> : null}
      <rect width="32" height="32" rx="6" fill="#998659" />
      <text
        x="16"
        y="23.5"
        textAnchor="middle"
        fontFamily="'Italiana','Cormorant Garamond',Georgia,serif"
        fontSize="24"
        fontStyle="italic"
        fontWeight="400"
        fill="#FAF5E6"
      >
        &amp;
      </text>
    </svg>
  );
}
